import { render, staticRenderFns } from "./order_purchase_add.vue?vue&type=template&id=33cbe088&scoped=true&"
import script from "./order_purchase_add.vue?vue&type=script&lang=js&"
export * from "./order_purchase_add.vue?vue&type=script&lang=js&"
import style0 from "./order_purchase_add.vue?vue&type=style&index=0&id=33cbe088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbe088",
  null
  
)

export default component.exports